import styled from '@emotion/styled';

import Image from 'components/Image';

export const BlogPostBox = styled.div`
  background: ${({ theme }) => theme.colors.secondary.white};
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding-bottom: 30px;
`;

export const Content = styled.div`
  padding: 10px;
`;

export const Title = styled.h2`
  font-size: 1.56rem;
`;

export const Split = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Author = styled.div`
  font-weight: 700;
`;

export const Description = styled.div`
  padding-top: 25px;
`;

export const Category = styled.div`
  font-size: 0.8rem;
  font-weight: 700;
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
  cursor: pointer;
  display: block;
  aspect-ratio: 2 / 1;
  object-fit: cover;
`;
